import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import _ from 'lodash'

import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'
import iconStyle from 'Styles/icon.css'
import panelStyle from 'Styles/panel.css'

import caretUp from 'Assets/caret-up-list.png'
import caretDown from 'Assets/caret-down-list.png'
import xIcon from 'Assets/x-icon-aqua.svg'
import redDot from 'Assets/redDot.png'
import yellowDot from 'Assets/yellowDot.png'
import greenDot from 'Assets/greenDot.png'
import progressDone from 'Assets/progress-done.svg'
import progressInProgress from 'Assets/progress-inprogress.svg'
import progressNotStarted from 'Assets/progress-not-started.svg'

export default class RetakeTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      columns: {
        name: -1,
        questionsReceived: 0,
        completion: 0,
        results: 0,
        retake: 0,
        score: 0
      }
    }
    if (this.props.students && this.props.students.length > 0) {
      const column = 'name'
      let sortValue = 0
      switch (this.state.columns[column]) {
        case 1:
          sortValue = 1
          break
        default:
          sortValue = -1
          break
      }
      this.props.students.sort(function (a, b) {
        if (a[column] > b[column]) {
          return sortValue
        }
        if (a[column] < b[column]) {
          return -(sortValue)
        }
        return 0
      })
    }
  }

  onStudentClick (student) {
    // toggle selected student off if clicked student is same as previously selected student
    student = this.state.selectedStudent != null && this.state.selectedStudent.id === student.id ? null : student
    this.setState({ selectedStudent: student })
    this.props.onStudentSelected(student)
  }

  renderStudentList () {
    const filter = this.props.studentFilter.toLowerCase()
    return this.props.students
      .filter(student => student.firstName.toLowerCase().includes(filter) || student.lastName.toLowerCase().includes(filter))
      .map(student => this.renderStudent(student))
  }

  sortColumnToValue (student, column) {
    const mappings = {
      results: s =>
        s.activity_state?.score >= s.activity_state?.target
          // value from 1-101
          ? this.convertTotalProgressToScore(s.activity_state?.tp) + 1
          : s.activity_state?.score >= 0
            // started = 0.5, not started = 0
            ? 0.5
            : 0,
      retake: s =>
        s.activity_state?.rt?.score >= s.activity_state?.rt?.target
          // value from 1-101
          ? this.convertTotalProgressToScore(s.activity_state?.rt?.tp)
          : s.activity_state?.rt?.score >= 0
            // started = 0.5, not started = 0
            ? 0.5
            : 0
    }
    if (mappings[column]) {
      return mappings[column](student) || 0
    } else {
      return student[column] || 0
    }
  }

  sortStudentList (column) {
    let sortValue = 0
    switch (this.state.columns[column]) {
      case 1:
        sortValue = -1
        break
      default:
        sortValue = 1
        break
    }
    this.props.students.sort((a, b) => {
      const aVal = this.sortColumnToValue(a, column)
      const bVal = this.sortColumnToValue(b, column)
      if (aVal > bVal) {
        return sortValue
      }
      if (aVal < bVal) {
        return -(sortValue)
      }
      return 0
    })
    this.renderStudentList()
    const newColumnStates = this.state.columns
    // reset all columns to clear sorting and caret display in render
    newColumnStates.name = 0
    newColumnStates.questionsReceived = 0
    newColumnStates.completion = 0
    newColumnStates.results = 0
    newColumnStates.retake = 0
    newColumnStates.score = 0
    newColumnStates[column] = sortValue
    this.setState({
      selectedStudent: null,
      columns: newColumnStates
    })
    this.props.onStudentSelected(null)
  }

  renderCompletedCheckbox () {
    return (
      <img
        alt="Completed checkbox"
        data-test-id="completedCheckbox"
        src={progressDone}
      />
    )
  }

  convertTotalProgressToScore = (tp = []) => {
    let totalPointsEarned = 0
    let totalPointsAvailable = 0
    tp.forEach(({ pe = 0, pa = 0 }) => {
      totalPointsEarned += pe
      totalPointsAvailable += pa
    })
    return Math.round(100 * totalPointsEarned / totalPointsAvailable)
  }

  renderGradedDot (tp) {
    let gradedDot = greenDot
    const score = this.convertTotalProgressToScore(tp)
    if (score < 70) {
      gradedDot = redDot
    } else if (score < 90) {
      gradedDot = yellowDot
    }
    return ([
      <img
        key={score}
        src={gradedDot}
        className={classnames(iconStyle.small, style.gradedDotImg)}
        alt={'graded dot'}
        tabIndex="-1"
      />,
      <label className={classnames(iconStyle.textIcon, iconStyle.textActivityRoster)}>{score}%</label>
    ])
  }

  renderProgressInfo (student, isComplete) {
    if (isComplete) {
      return (
        <div>
          {
            this.props.browser.lessThan.medium
              ? this.renderGradedDot(student.activity_state.tp)
              : this.renderCompletedCheckbox()
          }
        </div>
      )
    }
    return <img src={progressInProgress} data-test-id="firstAttemptInProgress" />
  }

  renderRetakeProgressInfo ({ activity_state: { rt: { score, target, tp } } }) {
    return (
      <div>
        {
          score >= target
            ? this.renderGradedDot(tp)
            : <img src={progressInProgress} data-test-id="retakeInProgress" />
        }
      </div>
    )
  }

  renderStudent (student) {
    let retakePctComplete

    if (student.activity_state.rt !== undefined) {
      retakePctComplete = Math.round(100 * (student.activity_state.rt.score / this.props.scoreTarget))
    } else {
      retakePctComplete = 0
    }

    const pctComplete = Math.round(100 * student.activity_state.score / this.props.scoreTarget)

    const isSelected = this.props.selectedStudent != null && student.id === this.props.selectedStudent.id
    const hasCompletedFirst = student.activity_state.score >= this.props.scoreTarget
    const {
      isMobile,
      selectedCategory
    } = this.props

    // Some students might have very long names without hyphens or spaces.
    // These long names will break the table, so check if any names are longer 12 characters
    // If so, insert a row for just for their special name

    const nameChunks = `${student.firstName} ${student.lastName}`
    const isBigAssName = _.some(nameChunks, chunk => chunk.length >= 12)

    const isNotCompletion = isMobile && selectedCategory !== 'completion'
    const isNotResults = isMobile && selectedCategory !== 'results'
    const isNotRetakes = isMobile && selectedCategory !== 'retakes'

    const cx = classnames.bind(style)
    const completionClasses = cx({
      studentCompletion: true,
      hide: isNotCompletion
    })

    const resultsClasses = cx({
      studentQuestionsWithDot: true,
      hide: isNotResults
    })

    const retakesClasses = cx({
      studentQuestions: true,
      hide: isNotRetakes
    })

    if (isBigAssName) {
      return ([
        <tr
          className={classnames(panelStyle.base, { [style.selectedRow]: isSelected }, style.bigNameRow)}
          data-test-id="studentListRow"
          key={student.id}
          onClick={() => this.onStudentClick(student)}
        >
          <td className={style.studentName} colSpan="4" data-test-id="studentListName">
            {this.renderStudentName(student.firstName, student.lastName, isSelected)}
          </td>
        </tr>,
        <tr
          className={classnames(panelStyle.base, { [style.selectedRow]: isSelected }, style.bigNameDataRow)}
          key={student.id}
          onClick={() => this.onStudentClick(student)}
          tabIndex="0"
        >
          <td>
            {/* Leave as blank placeholder so progress data appears under correct column */}
          </td>
          <td className={completionClasses} data-test-id="studentListClassCompletion">
            {pctComplete === 0
              ? <img src={progressNotStarted} data-test-id="firstAttemptNotStarted" />
              : this.renderProgressInfo(student, student.activity_state.score >= this.props.scoreTarget)
            }
          </td>
          <td className={resultsClasses} data-test-id="studentListCompletedFirst">
            {hasCompletedFirst ? this.renderGradedDot(student.activity_state.tp) : '-'}
          </td>
          <td className={retakesClasses} data-test-id="studentListRetakePercentage">
            {retakePctComplete === 0 ? '-' : this.renderRetakeProgressInfo(student)}
          </td>
        </tr>
      ])
    }

    return (
      <tr
        className={classnames(panelStyle.base, { [style.selectedRow]: isSelected })}
        data-test-id="studentListRow"
        key={student.id}
        onClick={() => this.onStudentClick(student)}
        tabIndex="0"
      >
        <td className={style.studentName} data-test-id="studentListName">
          {this.renderStudentName(student.firstName, student.lastName, isSelected)}
        </td>
        <td className={completionClasses} data-test-id="studentListClassCompletion">
          {pctComplete === 0
            ? <img src={progressNotStarted} data-test-id="firstAttemptNotStarted" />
            : this.renderProgressInfo(student, student.activity_state.score >= this.props.scoreTarget)
          }
        </td>
        <td className={resultsClasses} data-test-id="studentListCompletedFirst">
          {hasCompletedFirst ? this.renderGradedDot(student.activity_state.tp) : '-'}
        </td>
        <td className={retakesClasses} data-test-id="studentListRetakePercentage">
          {retakePctComplete === 0 ? '-' : this.renderRetakeProgressInfo(student)}
        </td>
      </tr>
    )
  }

  renderStudentName (firstName, lastName, isSelected) {
    let cssClass = ''
    let icon = ''
    if (isSelected) {
      cssClass = style.selectedStudent
      icon = <img aria-hidden="true" className={style.icon} src={xIcon} />
    }
    return (
      <div>
        {icon}
        <span className={cssClass}>{firstName}<span className={style.studentLastName}>{lastName}</span></span>
      </div>
    )
  }

  renderNoStudents () {
    return (
      <tr className={panelStyle.base}>
        <td colSpan="4" className={style.noStudents}>No students enrolled</td>
      </tr>
    )
  }

  renderTableHeaders () {
    const {
      isMobile,
      selectedCategory
    } = this.props

    const isNotCompletion = isMobile && selectedCategory !== 'completion'
    const isNotResults = isMobile && selectedCategory !== 'results'
    const isNotRetakes = isMobile && selectedCategory !== 'retakes'

    const cx = classnames.bind(style)
    const completionClasses = cx({
      questionsHeader: true,
      hide: isNotCompletion
    })

    const resultsClasses = cx({
      questionsHeader: true,
      hide: isNotResults
    })

    const retakesClasses = cx({
      questionsHeader: true,
      hide: isNotRetakes
    })

    return (
      <tr>
        <th
          key='name'
          className={style.studentNameHeader}
          onClick={() => this.sortStudentList('name')}
        >
          Name
          {this.state.columns.name !== 0
            ? (
                this.state.columns.name === 1
                  ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt={'caret up'} />
                  : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt={'caret down'} />
              )
            : null
          }
        </th>
        <th
          key={'completion'}
          className={completionClasses}
          onClick={() => this.sortStudentList('completion')}
        >
          Completion
          {this.state.columns.completion !== 0
            ? (
                this.state.columns.completion === 1
                  ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt={'caret up'} />
                  : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt={'caret down'} />
              )
            : null
          }
        </th>
        <th
          key={'results'}
          className={resultsClasses}
          onClick={() => this.sortStudentList('results')}
        >
          Results
          {this.state.columns.results !== 0
            ? (
                this.state.columns.results === 1
                  ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt={'caret up'} />
                  : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt={'caret down'} />
              )
            : null
          }
        </th>
        <th
          key={'retake'}
          className={retakesClasses}
          onClick={() => this.sortStudentList('retake')}
        >
          Retake
          {this.state.columns.retake !== 0
            ? (
                this.state.columns.retake === 1
                  ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt={'caret up'} />
                  : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt={'caret down'} />
              )
            : null
          }
        </th>
      </tr>
    )
  }

  render () {
    const hasStudents = this.props.students && this.props.students.length > 0
    return (
      <div>
        <table className={classnames(panelStyle.small, style.studentTable)}>
          <thead className={classnames(panelStyle.base, style.studentList)}>
            {this.renderTableHeaders()}
          </thead>
          <tbody className={style.studentTableBody}>
            {hasStudents
              ? this.renderStudentList()
              : this.renderNoStudents()}
          </tbody>
        </table>
      </div>
    )
  }
}

RetakeTable.propTypes = {
  browser: PropTypes.object,
  students: PropTypes.array.isRequired,
  scoreTarget: PropTypes.number.isRequired,
  studentFilter: PropTypes.string,
  onStudentSelected: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string,
  isMobile: PropTypes.bool,
  selectedStudent: PropTypes.object
}
